<script>
import appConfig from "@/app.config";

import { loaderComputed } from "@/state/helpers";

export default {
  name: "app",
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    }
  },

  computed: {
    ...loaderComputed
  },
};
</script>

<template>
  <div id="app">    
    <div class="page" v-if="loading">
      <b-spinner class="spinner" variant="primary" key="primary"></b-spinner>
    </div>
    <RouterView />
  </div>
</template>

<style scoped>
.page {
  position: absolute;
  background: rgba(0, 0, 0, 0.3);
  z-index: 25;
  width: 100%;
  height: 100%;
}

.spinner {
  position: relative;
  top: 384px;
  left: 50%;
}
</style>
